<template>
        <div style="display: flex; flex-direction: row; width: 100%">
            <div>
                <i class="fas fa-check-circle" style="color: #1EB5AB; margin-right: 10px"></i>
            </div>
            <div style="width: 100%; display: flex; flex-direction: column; justify-content: space-between">
                <div style="width: 100%">{{respuesta.answers}}</div>
                <div style="display: flex; flex-direction: row; width: 100%; padding-top: 10px; justify-content: flex-end; align-items: center">
                    <div style="margin-right: 10px; display: flex; flex-direction: row">
                        <div style="text-align: right; font-size: .7rem">{{respuesta.user.person.people_first_name}} </div>&nbsp;
                        <div style="text-align: right; font-size: .7rem">{{respuesta.user.person.people_surnames}} </div>
                    </div>
                    <div style="cursor: pointer; color:#FE4351" v-if="respuesta.user_id == this.userId.id" @click.prebent="deleteAnswers(respuesta.id)">
                        <span >
                            <i class="fas fa-times" v-if="stateButon === false"></i>
                             <p v-else>Espere...</p>
                        </span>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {mapGetters} from 'vuex'
    import axios from 'axios'
    export default {
        name:'Answers',
        props:['respuesta'],
        data() {
            return {
                stateButon: false
            }
        },
        components: {

        },
        computed: {
            ...mapGetters([
            ]),
            userId() {
                return JSON.parse(localStorage.getItem('user'));
            },
            courseId () {
                return localStorage.getItem('mountedCourseId')
            }
        },


        methods: {
            deleteAnswers: function (id) {
                this.stateButon = true
                var url = '/api/v1/students/answers/deleteAnswers';
                var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('a_t');
                axios.post(url, {
                    headers: {
                        token
                    },
                    mounted_course_id: this.courseId,
                    answer_id: id,
                }).then(response => {
                    if (response.data == 401){
                        toastr.error('Acción fallida...');
                        this.stateButon = false
                    }else{
                        this.$store.commit('questions', response.data);
                        this.stateButon = false
                    }

                });
            }
        }    
    }
</script>
<style scoped>
    .main-questions{
        display: flex;
        flex-direction: column;
        background-color: #F0F0F0;
        border-radius: 10px;
        padding: 10px;
    }
    .top-questions{
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        padding-top: 10px;
        padding-bottom: 10px
    }
</style>
